import { render, staticRenderFns } from "./SliderEventsFeedWidget.vue?vue&type=template&id=0e0d31c6&"
import script from "./SliderEventsFeedWidget.vue?vue&type=script&lang=js&"
export * from "./SliderEventsFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0d31c6')) {
      api.createRecord('0e0d31c6', component.options)
    } else {
      api.reload('0e0d31c6', component.options)
    }
    module.hot.accept("./SliderEventsFeedWidget.vue?vue&type=template&id=0e0d31c6&", function () {
      api.rerender('0e0d31c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/SliderEventsFeedWidget.vue"
export default component.exports